import React from 'react';
import { useTranslation } from 'react-i18next';
import MonthYearFilter, { MonthYearValue } from './MonthYearFilter';
import ViewModeToggle, { ViewMode } from './ViewModeToggle';

interface HeaderProps {
  period: MonthYearValue;
  onPeriodChange: (value: MonthYearValue) => void;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const Header: React.FC<HeaderProps> = ({ period, onPeriodChange, viewMode, onViewModeChange }) => {
  const { t } = useTranslation();

  return (
    <div className="row mb-6 align-items-center">
      <div className="col-sm-6">
        <h4 className="m-0 fw-bold">{t('dashboard.pageTexts.header.title')}</h4>
        <p className="mb-0">{t('dashboard.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-sm-6 d-flex justify-content-sm-end align-items-center gap-3 mt-3 mt-sm-0">
        <ViewModeToggle value={viewMode} onChange={onViewModeChange} />
        <MonthYearFilter value={period} onChange={onPeriodChange} />
      </div>
    </div>
  );
};

export default Header;
